import React from "react";
import { useTranslation } from "react-i18next";
import { useColors } from "../../constants/Colors";
import StepWrapper from "./StepWrapper";
import {
  CreateFlatStore,
  PROFILE_TEXT_MAX_LENGTH,
  FLAT_TEXT_MIN_LENGTH,
} from "../../hooks/useCreateFlatStore";

interface Props {
  store: CreateFlatStore;
}

const DescriptionStep: React.FC<Props> = ({ store }) => {
  const { t } = useTranslation();
  const { textNeutralDefault, textNeutralMuted } = useColors();

  const charCount = store.description.length;
  const isNearLimit = charCount >= PROFILE_TEXT_MAX_LENGTH * 0.9;
  const isBelowMin = charCount > 0 && charCount < FLAT_TEXT_MIN_LENGTH;

  return (
    <StepWrapper
      title={t("flats_tab.add_flat.flat_text_title") || "Describe your flat"}
      subtitle={
        t("flats_tab.add_flat.flat_text_subtitle") ||
        "Tell potential roommates about your flat and the people living there"
      }
    >
      <div>
        <textarea
          value={store.description}
          onChange={(e) => {
            if (e.target.value.length <= PROFILE_TEXT_MAX_LENGTH) {
              store.setDescription(e.target.value);
            }
          }}
          placeholder={
            t("flats_tab.add_flat.flat_text_placeholder") ||
            "Tell us about your flat, the neighborhood, and what kind of roommate you're looking for..."
          }
          rows={7}
          className="cf-textarea"
          style={{ color: textNeutralDefault }}
        />
        <div className="flex items-center justify-between mt-3 px-1">
          {isBelowMin ? (
            <span className="text-xs" style={{ color: textNeutralMuted }}>
              {FLAT_TEXT_MIN_LENGTH - charCount} {t("more_characters") || "more characters needed"}
            </span>
          ) : (
            <span />
          )}
          <span
            className="text-xs tracking-wide"
            style={{
              color: isNearLimit ? "#DC362E" : textNeutralMuted,
            }}
          >
            {charCount}/{PROFILE_TEXT_MAX_LENGTH}
          </span>
        </div>
      </div>
    </StepWrapper>
  );
};

export default DescriptionStep;
